import { render } from "./IconHealthAndSafety.vue?vue&type=template&id=25c0e8cc"
import script from "./IconHealthAndSafety.vue?vue&type=script&lang=js"
export * from "./IconHealthAndSafety.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__